var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.componentKey},[_c('vue-pivottable-ui',{attrs:{"data":_vm.getItems,"rows":_vm.rows,"cols":_vm.cols,"row-total":false,"column-total":false,"locales":_vm.locales,"locale":_vm.locale},model:{value:(_vm.pivoTable),callback:function ($$v) {_vm.pivoTable=$$v},expression:"pivoTable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }